export const ADDRESS_UPDATE_VISIBLE_UNTIL = new Date('2026-07-02T00:00:00');

export function isAddressUpdateActive() {
  return Date.now() < ADDRESS_UPDATE_VISIBLE_UNTIL.getTime();
}
